import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { withRouter } from 'react-router'
import ReactGA from "react-ga4"
import getWidgetsOrigin from '../getWidgetsOrigin'
import getStrings from 'getStrings'
import getLanguage from 'getLanguage'
import AppContext from 'core/appContext'
import { cancelStripeSubscription } from "../../Uluweb";
import qs from "qs";

const ERRORS = { // This contains errors coming both from Uluweb and Playfab, hence the different format.
    en: {
        GENERIC_ERROR: 'Our servers encountered an error.'
    },
    fr: {
        GENERIC_ERROR: 'Nos serveurs ont rencontré une erreur.'
    }
}

class WidgetsStripeCancelForm extends React.Component {

    constructor(props) {
        super(props)

        const parentOrigin = getWidgetsOrigin()

        const { subscriptionID } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        console.log('widget subscriptionID: ', subscriptionID)
        if (!subscriptionID)
            console.error('No subscription found!')

        this.state = {
            parentOrigin: parentOrigin,
            subscriptionID: subscriptionID,
            loading: false
        }

    }

    componentDidMount() {
        // eslint-disable-next-line no-undef
        gtag('get', process.env['REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID'], 'client_id', (clientID) => {
            this.setState({googleClientID: clientID})
        })
    }

    cancelClicked = async (event) => {
        event.preventDefault()

        if (!this.state.parentOrigin) {
            alert('Invalid parent origin!')
            return
        }

        if (!this.state.subscriptionID) {
            alert('No subscription found!')
            return
        }

        try {
            this.setState({ loading: true });

            // ****** Cancel the subscription ******
            const responseCancellation = await cancelStripeSubscription(this.state.subscriptionID)
            if (!responseCancellation?.data?.success) {
                console.log('responseCancellation?.data: ', responseCancellation?.data)
                throw new Error(responseCancellation?.data?.error)
            }

            window.parent.postMessage(
                {
                    type: "Cancellation_SUCCESS"
                },
                this.state.parentOrigin
            )
        } catch (err) {
            if (err?.message === 'INVALID_PAYLOAD')
                // Prevent further actions by the user for these errors.
                this.setState({ loading: true })
            else
                this.setState({ loading: false })

            this.displayError(err?.message ?? err)
        }
    }

    displayError = (errorCode) => {
        const language = getLanguage()
        if (!errorCode || Object.keys(errorCode).length === 0) {
            console.error('stripe.displayError: generic: ', errorCode)
            return alert(ERRORS[language].GENERIC_ERROR)
        }

        console.error(`stripe.displayError: ${errorCode}`)
        alert(ERRORS[language].hasOwnProperty(errorCode) ? ERRORS[language][errorCode] : ERRORS[language]['GENERIC_ERROR'])
    }

    render() {
        const strings = getStrings()

        return (
            <div className='form-box'>
                <form id='formCancel'>
                    <button
                        data-form='formCancel'
                        onClick={this.cancelClicked.bind(this)}
                        disabled={this.state.loading}
                        className="form-button"
                        type='submit'
                        style={{ backgroundColor: '#FF9408' }}
                    >
                        {this.state.loading ? strings.GENERIC_PROCESSING : strings.STRIPE_CANCEL_BUTTON}
                    </button>
                </form>
            </div>
        )
    }
}

WidgetsStripeCancelForm.contextType = AppContext

export default withRouter(WidgetsStripeCancelForm)